import { render, staticRenderFns } from "./ADTableExpansion.vue?vue&type=template&id=5fa12901&scoped=true&"
import script from "./ADTableExpansion.vue?vue&type=script&lang=js&"
export * from "./ADTableExpansion.vue?vue&type=script&lang=js&"
import style0 from "./ADTableExpansion.vue?vue&type=style&index=0&id=5fa12901&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa12901",
  null
  
)

export default component.exports